module.exports = __webpack_public_path__ + "static/img/card_1_1.b98125e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en/card_1_1.png
// module id = Ph8F
// module chunks = 0